module.exports = __webpack_public_path__ + "static/img/sdgs_reuse_ph.b636fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sdgs_reuse_ph.png
// module id = Q13I
// module chunks = 0